import { FC } from '../../../Services'

export const reexecuteUnit = (unit, initialState) =>
  FC.service('public').create({ ...initialState, type: 'testUnit', unit, isDebug: true })
